import { Container, ContainerPadding, TextInput } from '@volkswagen-onehub/components-core';
import React from 'react';
import { getLang, getTranslations } from '../../../../translations';
import { formatCurrency } from '../../../../utils/format';

interface DownpaymentInterface {
    downPaymentHandler : Function
}

const Downpayment = ({downPaymentHandler} : DownpaymentInterface) => {
    const lang = getLang();
    const trans = getTranslations();

    const inputHandler = (e: React.SyntheticEvent<HTMLInputElement>): void => {
        let value : string = e.currentTarget.value;

        downPaymentHandler(value);
    };

    return <Container
                wrap="always"
                padding={{ top: ContainerPadding.static150, bottom: ContainerPadding.static150 }}>
                <TextInput
                    placeholder={formatCurrency(0, true, lang)}
                    label={trans.details.calculator.payment_finance_down}
                    onChange={(e: React.SyntheticEvent<HTMLInputElement>) => inputHandler(e)} />
            </Container>
}

export default Downpayment;
